import { createStore } from 'vuex';

export default createStore({
    state: {
        user_id: null,
        current_date: null,
        company_name: 'Street Shopping',
        city_name: 'Barranquilla',
    },
    mutations: {
    },
    actions: {
    },
});